import { render, staticRenderFns } from "./addTag.vue?vue&type=template&id=e5dc6496&scoped=true&"
import script from "./addTag.vue?vue&type=script&lang=js&"
export * from "./addTag.vue?vue&type=script&lang=js&"
import style0 from "./addTag.vue?vue&type=style&index=0&id=e5dc6496&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5dc6496",
  null
  
)

export default component.exports